import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { ReactComponent as BackArrowIcon } from "../../../assets/rewamp/navigation/keyboard-backspace.svg";

// Self-contained: legacy pages (DefaultLayout Outlet) have no navBack recipe, so fill and shape are set here.
const PWA_BACK_SX = {
  flexShrink: 0,
  minWidth: 0,
  gap: 0.5,
  borderRadius: 2,
  backgroundColor: "primary.main",
  color: "common.white",
  fontSize: "12px",
  fontWeight: 600,
  boxShadow: "none",
  "&.MuiButton-sizeMedium": { py: 0.5, px: 1, borderRadius: 2, fontSize: "12px" },
  "& .MuiButton-startIcon": { m: 0 },
  "&:hover": { backgroundColor: "primary.dark", boxShadow: "none" },
};

export default function PwaBackButton({ onClick, label }) {
  return (
    <Button
      onClick={onClick}
      disableElevation
      variant="navBack"
      startIcon={<BackArrowIcon aria-hidden="true" width={16} height={16} />}
      sx={PWA_BACK_SX}
    >
      {label}
    </Button>
  );
}

PwaBackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};
